import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import React, { useRef } from 'react';
import useWebContext from '../hooks/useWebContext';
import { MyMButton } from '../ui-elements/MyMButton';
import { MyMTextBox } from '../ui-elements/MyMTextBox';
import { MyMTooltip } from '../ui-elements/MyMToolTip';

/** MyMine Version2.1 Share機能実装のため新規追加
* CopyDialog Component
*/
export const CopyDialog = ({ screenId, isOpen, onClose, copyText }) => {
  const { controlSettings, messageList } = useWebContext(screenId);
  const [openCopiedTip, setOpenCopiedTip] = React.useState(false);
  const inputRef = useRef(null);
  const clearHiddenCopied = React.useRef(null);

  const onClickCopy = () => {

    inputRef.current.select();

    // ツールチップ表示
    setOpenCopiedTip(true);

    // クリップボードにコピー
    navigator.clipboard.writeText(copyText);

    if (clearHiddenCopied.current) {
      clearTimeout(clearHiddenCopied.current);
    }

    // 既定秒後にクリップボード非表示
    clearHiddenCopied.current = setTimeout(() => {
      setOpenCopiedTip(false);
    }, 1500);
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth='lg'
      onClose={onClose}
      open={isOpen}
      sx={{
        '& .MuiDialogContent-root': {
          padding: 3,
        },
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        {controlSettings.LabelList.lblShare}
      </DialogTitle>
      <IconButton
        onClick={onClose}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <MyMTextBox
          width='calc(100% - 70px)'
          inputValue={copyText}
          inputRef={inputRef}
          inputProps={{
            readOnly: true,
          }}
          onFocus={(e) => { e.target.select(); }}
          sx={{
            '& .MuiInputBase-root': {
              borderRadius: '6px 0 0 6px'
            },
          }}
        />

        <MyMTooltip
          arrow
          open={openCopiedTip}
          onClose={() => {
            setOpenCopiedTip(false);
          }}
          disableHoverListener
          placement='top'
          title={messageList.MyM_MSG_I_0153}
        >
        </MyMTooltip>
        <MyMButton
          sx={{
            width: '50px',
            borderRadius: '0 6px 6px 0'
          }}
          onClick={onClickCopy}
        >
          {controlSettings.LabelList.lblCopy}
        </MyMButton>
      </DialogContent>
    </Dialog>
  );
};